import { render, staticRenderFns } from "./DetailType3.vue?vue&type=template&id=5fce51dd&"
import script from "./DetailType3.vue?vue&type=script&lang=js&"
export * from "./DetailType3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports